import React from 'react';
import { Link } from 'react-router-dom';

// Shown to logged-out (guest) visitors at the point they try to book or pay.
// Browsing classes, treatments and prices is open to everyone (Apple Guideline
// 5.1.1(v)); only the account-based action of booking/paying needs a login.
export default function LoginToBook({ message = 'Log in or create a free account to book.' }) {
  return (
    <div className="card" style={{ padding: 20, textAlign: 'center' }}>
      <div style={{ fontSize: '1.6rem', marginBottom: 8 }}>🔒</div>
      <div style={{ fontWeight: 800, marginBottom: 6 }}>Almost there</div>
      <p style={{ color: 'var(--grey-700)', fontSize: '0.88rem', marginBottom: 16, lineHeight: 1.5 }}>{message}</p>
      <Link to="/login" className="btn btn-primary btn-full" style={{ marginBottom: 10 }}>Log In</Link>
      <Link to="/signup" className="btn btn-secondary btn-full">Create Account</Link>
    </div>
  );
}
